<div [class.note]="noteMode" class="root-container">
  <div class="main-container" [style.cursor]="mainCursor" (click)="onMainClick($event)">
    <div [style.width]="leftBlockWidthVal">
      <div class="row-new">
        <div>
          <input class="inp-1"[(ngModel)]="textNewSubItem" placeholder="Пункт задачи" (blur)="textNewSubItem=''" (keypress)="onNewSubItemKeyPress($event)" />
        </div>
        <div>
          <button class="btn-1 left sub-item-create" (click)="subItemCreateClick()">+</button>
        </div>
      </div>
      <div>
        @if (!model.taskItem.finalMessageHidden && model.taskItem.state==TaskTrackerItemState.Done) {
          <div class="task-done"
            (click)="finalMessageClick()">
            Готово! Ура! <br> Дело сделано! <br>Ты молодец!
          </div>
        }
        @for (item of model.taskItem.subItems; track item) {
          <div class="sub-item-row" [class.edit]="item.edit" (click)="subItemClick(item, $event)"
            [class.in-progress]="item.state==TaskTrackerItemState.InProgress"
            [class.done]="item.state==TaskTrackerItemState.Done"
            [class.removed]="item.state==TaskTrackerItemState.Removed"
            >
            <div class="state">{{ item.state==TaskTrackerItemState.Removed ? '&ndash;' : '&nbsp;'}}</div>
            <span class="position">{{item.position}}</span>. {{item.name}}
            @if (item.edit) {
              <div class="edit">
                <div>
                  @if (item.edit) {
                    <input type="number" [(ngModel)]="editingSubItem.positionEdit" class="number-2dig" />
                    }.
                  </div>
                  <div class="name">
                    <input [(ngModel)]="editingSubItem.nameEdit"/>
                  </div>
                  @if (item.edit) {
                    <div class="buttons">
                      <button class="btn-1 left" (click)="subItemSaveClick()">Сохранить</button>
                      <button class="btn-1" (click)="subItemCancelClick()">Отмена</button>
                    </div>
                  }
                </div>
              }
              @if (item.menuOpened) {
                <app-context-menu [items]="contextMenuItems"
                  [pos]="contextMenuPosition"
                  (select)="onMenuItemSelect($event)"
                (close)="onMenuItemClose(item)"></app-context-menu>
              }
            </div>
          }
        </div>
      </div>
      <div (click)="onResizeLeftClick()"></div>
      <div>
        <div [innerHTML]="model.trackerItemMainTextInnerHtml" #mainText (input)="onMainTextInput(mainText.innerHTML)" contenteditable="true" class="editor" (keyup)="onMainTextKeyUp()"></div>
      </div>
    </div>
  </div>